import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

export function getTopology(token: string) {
    return axios.get(`${API_URL}/v1/resource-manager/ke-topology`, {
        headers: { Authorization: `Bearer ${token}` },
    });
}

export function getBaselineLatencies(token: string) {
    return axios.get(
        `${API_URL}/v1/resource-manager/ke-topology/baseline`,
        {
            headers: { Authorization: `Bearer ${token}` },
        }
    );
}

/**
 * Legacy: dedicated links-by-algo endpoint (flex-algo spec §3.3).
 * Traffic mode on the topology graph uses `GET /srv6-insight/ddm`
 * instead — see `linksByAlgoFromDdmDemands` in TopologyData.ts.
 */
export function getLinksByAlgo(
    token: string,
    algorithm: number,
    timeRange = '1h'
) {
    return axios.get(
        `${API_URL}/v1/resource-manager/srv6-insight/links-by-algo`,
        {
            headers: { Authorization: `Bearer ${token}` },
            params: { algorithm, timeRange },
        }
    );
}
